module.exports = __webpack_public_path__ + "static/media/emj09.c59c1e8d.svg";